// @ts-check
import { AppRoutes } from "./appRoutes.consts"
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded"
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined"
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined"
import EventIcon from "@mui/icons-material/Event"
import { Role } from "./roles.consts"

export const APP_MENU_OVERLAYS = {
  SHORTCUTS: "shortcuts",
}

/** @type {import("../types/appMenu").AppMenuItem[]} */
export const APP_MENU = [
  {
    name: "Dashboard",
    icon: DashboardOutlinedIcon,
    path: AppRoutes.dashboard.index,
  },
  {
    name: "Actividades",
    icon: ChecklistRoundedIcon,
    modules: [
      {
        name: "Registro diario",
        path: AppRoutes.registroTiempos.index,
      },
      {
        name: "Lista de pendientes",
        path: AppRoutes.listaPendientes.index,
      },
    ],
  },
  {
    name: "Reportes",
    iconClass: "pi pi-chart-line",
    modules: [
      {
        name: "General",
        path: AppRoutes.reporteGeneral.index,
      },
      {
        name: "Cliente",
        path: AppRoutes.reporteCliente.index,
      },
      {
        name: "Individual",
        path: AppRoutes.reporteIndividual.index,
      },
      {
        name: "Facturación",
        path: AppRoutes.reporteOcupacion.index,
      },
    ],
  },
  {
    name: "Vacaciones",
    icon: BeachAccessOutlinedIcon,
    roles: [Role.ADMIN, Role.ADMIN_WITHOUT_REPORT],
    modules: [
      {
        name: "Reporte de vacaciones",
        path: AppRoutes.vacaciones.reporteVacaciones,
      },
      {
        name: "Gestión de vacaciones",
        path: AppRoutes.vacaciones.gestion,
      },
      {
        name: "Mis vacaciones",
        path: AppRoutes.vacaciones.index,
      },
    ],
  },
  {
    name: "Vacaciones",
    icon: BeachAccessOutlinedIcon,
    roles: [Role.TEAM_MEMBER, Role.TEAM_LEADER],
    modules: [
      {
        name: "Mis vacaciones",
        path: AppRoutes.vacaciones.index,
      },
      {
        name: "Historial de vacaciones",
        path: AppRoutes.vacaciones.historialVacacionesMiembroEquipo,
      },
    ],
  },
  {
    name: "Administración",
    iconClass: "pi pi-briefcase",
    modules: [
      {
        name: "Clientes",
        path: AppRoutes.clientes.index,
      },
      {
        name: "Integrantes",
        path: AppRoutes.integrantes.index,
      },
    ],
  },
  {
    name: "Atajos",
    iconClass: "pi pi-bolt",
    roles: [Role.ADMIN, Role.ADMIN_WITHOUT_REPORT, Role.TEAM_LEADER],
    overlay: APP_MENU_OVERLAYS.SHORTCUTS,
  },
  {
    name: "Sandbox",
    iconClass: "pi pi-code",
    path: AppRoutes.sandbox.index,
  },
  {
    name: "Configuración",
    iconClass: "pi pi-cog",
    path: AppRoutes.configuracion.index,
  },
  {
    name: "Notas de la versión",
    iconClass: "pi pi-clock",
    path: AppRoutes.changeLog.index,
  },
  {
    name: "Estimaciones",
    icon: EventIcon,
    modules: [
      {
        name: "Agente",
        path: AppRoutes.estimations.agent.chat,
      },
    ],
  },
]
